import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";

import AppCard from "../../Components/common/AppCard/AppCard";
import IntegrationConfigList from "../../Components/common/IntegrationConfigList/IntegrationConfigList";
import IntegrationModal from "../../Components/PagesComponents/IntegrationsMarket/IntegrationModal/IntegrationModal";

import WinshareSettings from "../../Components/PagesComponents/IntegrationsMarket/WinshareSettings/WinshareSettings";
import RclshareSettings from "../../Components/PagesComponents/IntegrationsMarket/RclshareSettings/RclshareSettings";
import ImapemailSettings from "../../Components/PagesComponents/IntegrationsMarket/ImapemailSettings/ImapemailSettings";
import CstrikeSettings from "../../Components/PagesComponents/IntegrationsMarket/CstrikeSettings/CstrikeSettings";
import PostfixemailSettings from "../../Components/PagesComponents/IntegrationsMarket/PostfixemailSettings/PostfixemailSettings";
import DefenderSettings from "../../Components/PagesComponents/IntegrationsMarket/DefenderSettings/DefenderSettings";
import TapInterfaceSettings from "../../Components/PagesComponents/IntegrationsMarket/TapInterfaceSettings/TapInterfaceSettings";
import BulkScanSettings from "../../Components/PagesComponents/IntegrationsMarket/BulkScanSettings/BulkScanSettings";
import IcapProxySettings from "../../Components/PagesComponents/IntegrationsMarket/IcapProxySettings/IcapProxySettings";

import {
  RequestCheckConfig,
  RequestGetConfig,
  ClearGetConfig,
} from "../../store/actions/integrationsActions";

import { CARD_DATA } from "./constants";

import "./styles.scss";

const CONFIG_COMPONENTS = {
  winshare: WinshareSettings,
  rclshare: RclshareSettings,
  imapemail: ImapemailSettings,
  cstrike: CstrikeSettings,
  defender: DefenderSettings,
  postfixemail: PostfixemailSettings,
  tapweb: TapInterfaceSettings,
  bulkscan: BulkScanSettings,
  icapweb: IcapProxySettings,
};

const noop = () => {};

const IntegrationMarket = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const query = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]);

  const conf = query.get("conf");
  const back = query.get("bck");
  const tempId = query.get("t");

  const [activeInt, setActiveInt] = useState("");
  const [listPopupActive, setListPopupActive] = useState(false);
  const [modalActive, setModalActive] = useState(false);
  const [modalType, setModalType] = useState("");

  const setConfig = useSelector((state) => state.integrations.setConfig);
  const deleteConfig = useSelector((state) => state.integrations.deleteConfig);
  const licenceCheck = useSelector((state) => state?.users.licenceCheck);
  const loadingUpdate = useSelector((state) => state.integrations.loadingUpdate);

  // 1. "Şu an hangi entegrasyonla ilgileniyoruz?" sorusuna
  const currentInt = activeInt || back || "";
  // 2. Popup'ın verisini bul:
  const activeCardData = CARD_DATA.find((c) => c.intname === currentInt && c.listPopup);
  // 3. Popup'ın açık olması gerektiğini hesapla (State true ise VEYA URL'de back varsa):
  const isPopupVisible = listPopupActive || (!!back && !!activeCardData);

  useEffect(() => {
    dispatch(RequestCheckConfig());
  }, [dispatch]);

  useEffect(() => {
    // Sadece activeInt değiştiğinde popup yönetimini yap
    if (!activeInt) {
      setListPopupActive(false);
      return;
    }

    const card = CARD_DATA.find((c) => c.intname === activeInt);

    if (card?.listPopup) {
      setListPopupActive(true);
      dispatch(RequestGetConfig(activeInt));
    } else {
      // Eğer listPopup yoksa direkt ayar sayfasına yönlendir
      history.push(`integration-market?conf=${activeInt}`);
    }
  }, [activeInt, dispatch, history]);

  useEffect(() => {
    // URL parametrelerini dinleyen ve sadece ana state'i (activeInt) güncelleyen kısım
    if (back) {
      // Önceki config datasını temizle
      // dispatch(ClearGetConfig());
      // Sadece activeInt'i setle, gerisini yukarıdaki effect halledecek
      setActiveInt(back);
      return;
    }

    if (conf) {
      // conf varsa ve postfix gibi özel bir durumsa data çek
      if (conf === "postfixemail") {
        dispatch(RequestGetConfig(conf));
      }
      return;
    }

    // Eğer URL'de ikisi de yoksa state'i temizle
    if (!conf && !back) {
      setActiveInt("");
      dispatch(ClearGetConfig());
    }
  }, [conf, back, dispatch]);

  useEffect(() => {
    if (setConfig === "Success") {
      history.push("/integration-market?bck=" + conf);
    }
  }, [setConfig]);

  useEffect(() => {
    if (deleteConfig === "Success" && tempId && !loadingUpdate) {
      history.push("/integration-market?bck=" + conf);
    }
  }, [deleteConfig]);

  const openModalHandler = (type) => {
    setModalActive(true);
    setModalType(type);
  };

  const closeModalHandler = () => setModalActive(false);

  const ActiveConfigComponent = CONFIG_COMPONENTS[conf] || null;

  return (
    <div className="integration-market">
      <div className="integration-market__header">
        <h1>Integration Market</h1>
        <p>You can add and install the integrations we have provided in this section.</p>
      </div>

      <div className="integration-market__cards">
        {CARD_DATA.map((cardData) => (
          <AppCard
            key={cardData.intname}
            cardIcon={
              <img
                src={cardData.imgSrc}
                className={cardData.imgClassName}
                alt={cardData.cardName}
              />
            }
            cardName={cardData.cardName}
            cardDescription={cardData.cardDescription}
            intname={cardData.intname}
            messageonly={cardData.messageonly}
            setActiveInt={setActiveInt}
            includedInLicense={
              licenceCheck?.integrations.includes(cardData.cardName) ||
              (licenceCheck?.integrations.length === 1 && licenceCheck?.integrations[0] === "all")
            }
            openModalHandler={openModalHandler}
          />
        ))}
      </div>

      {modalActive && (
        <IntegrationModal closeModalHandler={closeModalHandler} modalType={modalType} />
      )}

      {isPopupVisible && (
        <IntegrationConfigList
          show={isPopupVisible}
          setShow={setListPopupActive}
          activeInt={currentInt}
          setActiveInt={setActiveInt}
          data={activeCardData}
        />
      )}

      {ActiveConfigComponent && (
        <ActiveConfigComponent
          show={true}
          setShow={noop}
          dataTmp={tempId}
          setActiveInt={setActiveInt}
          activeInt={activeInt || conf}
        />
      )}
    </div>
  );
};

export default IntegrationMarket;
